import { ShieldCheck } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const supplierQualityNav: NavEntry = {
  label: 'Supplier quality',
  icon: ShieldCheck,
  path: '/suppliers/quality',
  permission: 'supplier_quality:read',
  order: 18,
}
